import React, { useEffect, useState } from "react";
import Header from "../component/layout/header";
import FooterSection from "../component/layout/footer";

function PrivacyPolicy() {
  return (
    <div>
      <Header />
      <div className="contact-section">
        <div
          className="contact-top padding-tb aside-bg"
          style={{
            "margin-left": "20px",
            "margin-right": "20px",
            "padding-top": "200px",
          }}
        >
          <div className="vc_row wpb_row vc_row-fluid vc_custom_1497013187222">
            <div className="row-container vc_row-flex row-default vc_row">
              <div className="wpb_column vc_column_container vc_col-sm-12">
                <div className="vc_column-inner ">
                  <div className="wpb_wrapper policy-wrapper">
                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <h1 class="BasePage__Title-sc-ue546c-2 hgBDdv">
                          Privacy Policy
                        </h1>
                      </div>
                    </div>

                    <div className="wpb_text_column wpb_content_element ">
                      <div className="wpb_wrapper">
                        <p>Last updated December 10, 2024</p>
                        <p>
                          This Privacy Notice for Tegal ('we', 'us', or 'our'),
                          describes how and why we might access, collect, store,
                          use, and/or share ('process') your personal
                          information when you use our services ('Services'),
                          including when you:
                        </p>

                        <ul>
                          <li>
                            Visit our website at https://tegalapp.com, or any
                            website of ours that links to this Privacy Notice
                          </li>
                          <li>
                            Download and use our mobile application (Tegal), or
                            any other application of ours that links to this
                            Privacy Notice
                          </li>
                          <li>
                            Use Connect with Your Soul Mate on Tegal. Tegal is a
                            premier matchmaking service dedicated to connecting
                            individuals from diverse backgrounds, tribes, and
                            religions for meaningful relationships that lead to
                            marriage. Our platform welcomes individuals from all
                            over the world, fostering a vibrant community that
                            celebrates love, diversity, and unity.
                          </li>
                          <li>
                            Engage with us in other related ways, including any
                            sales, marketing, or events
                          </li>
                        </ul>

                        <p>
                          Questions or concerns? Reading this Privacy Notice
                          will help you understand your privacy rights and
                          choices. We are responsible for making decisions about
                          how your personal information is processed. If you do
                          not agree with our policies and practices, please do
                          not use our Services. If you still have any questions
                          or concerns, please contact us at hello@tegalapp.com.
                        </p>

                        <h2>SUMMARY OF KEY POINTS</h2>
                        <p>
                          This summary provides key points from our Privacy
                          Notice, but you can find out more details about any of
                          these topics by clicking the link following each key
                          point or by using our table of contents below to find
                          the section you are looking for.
                        </p>

                        <h3>What personal information do we process?</h3>
                        <p>
                          When you visit, use, or navigate our Services, we may
                          process personal information depending on how you
                          interact with us and the Services, the choices you
                          make, and the products and features you use. Learn
                          more about personal information you disclose to us.
                        </p>

                        <h3>
                          Do we process any sensitive personal information?
                        </h3>
                        <p>
                          Some of the information may be considered 'special' or
                          'sensitive' in certain jurisdictions, for example your
                          racial or ethnic origins, sexual orientation, and
                          religious beliefs. We do not process sensitive
                          personal information.
                        </p>

                        <h3>
                          Do we collect any information from third parties?
                        </h3>
                        <p>
                          We do not collect any information from third parties.
                        </p>

                        <h3>How do we process your information?</h3>
                        <p>
                          We process your information to provide, improve, and
                          administer our Services, communicate with you, for
                          security and fraud prevention, and to comply with law.
                          We may also process your information for other
                          purposes with your consent. We process your
                          information only when we have a valid legal reason to
                          do so. Learn more about how we process your
                          information.
                        </p>

                        <h3>
                          In what situations and with which parties do we share
                          personal information?
                        </h3>
                        <p>
                          We may share information in specific situations and
                          with specific third parties. Learn more about when and
                          with whom we share your personal information.
                        </p>

                        <h3>How do we keep your information safe?</h3>
                        <p>
                          We have adequate organisational and technical
                          processes and procedures in place to protect your
                          personal information. However, no electronic
                          transmission over the internet or information storage
                          technology can be guaranteed to be 100% secure, so we
                          cannot promise or guarantee that hackers,
                          cybercriminals, or other unauthorised third parties
                          will not be able to defeat our security and improperly
                          collect, access, steal, or modify your information.
                          Learn more about how we keep your information safe.
                        </p>

                        <h3>What are your rights?</h3>
                        <p>
                          Depending on where you are located geographically, the
                          applicable privacy law may mean you have certain
                          rights regarding your personal information. Learn more
                          about your privacy rights.
                        </p>

                        <h3>How do you exercise your rights?</h3>
                        <p>
                          The easiest way to exercise your rights is by
                          submitting a data subject access request, or by
                          contacting us. We will consider and act upon any
                          request in accordance with applicable data protection
                          laws.
                        </p>

                        <p>
                          Want to learn more about what we do with any
                          information we collect? Review the Privacy Notice in
                          full.
                        </p>

                        <h2>TABLE OF CONTENTS</h2>
                        <ol>
                          <li>WHAT INFORMATION DO WE COLLECT?</li>
                          <li>HOW DO WE PROCESS YOUR INFORMATION?</li>
                          <li>
                            WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL
                            INFORMATION?
                          </li>
                          <li>HOW DO WE HANDLE YOUR SOCIAL LOGINS?</li>
                          <li>HOW LONG DO WE KEEP YOUR INFORMATION?</li>
                          <li>HOW DO WE KEEP YOUR INFORMATION SAFE?</li>
                          <li>DO WE COLLECT INFORMATION FROM MINORS?</li>
                          <li>WHAT ARE YOUR PRIVACY RIGHTS?</li>
                          <li>CONTROLS FOR DO-NOT-TRACK FEATURES</li>
                          <li>
                            DO OTHER REGIONS HAVE SPECIFIC PRIVACY RIGHTS?
                          </li>
                          <li>DO WE MAKE UPDATES TO THIS NOTICE?</li>
                          <li>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</li>
                          <li>
                            HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE
                            COLLECT FROM YOU?
                          </li>
                        </ol>

                        <h2>1. WHAT INFORMATION DO WE COLLECT?</h2>
                        <h3>Personal information you disclose to us</h3>
                        <p>
                          <em>In Short:</em> We collect personal information
                          that you provide to us.
                        </p>
                        <p>
                          We collect personal information that you voluntarily
                          provide to us when you register on the Services,
                          express an interest in obtaining information about us
                          or our products and Services, when you participate in
                          activities on the Services, or otherwise when you
                          contact us.
                        </p>
                        <p>
                          <strong>Personal Information Provided by You.</strong>{" "}
                          The personal information that we collect depends on
                          the context of your interactions with us and the
                          Services, the choices you make, and the products and
                          features you use. The personal information we collect
                          may include the following:
                        </p>
                        <ul>
                          <li>names</li>
                          <li>phone numbers</li>
                          <li>email addresses</li>
                          <li>job titles</li>
                          <li>usernames</li>
                          <li>passwords</li>
                          <li>contact preferences</li>
                          <li>contact or authentication data</li>
                          <li>life style information</li>
                          <li>photos</li>
                          <li>gender</li>
                          <li>genotype</li>
                          <li>blood group</li>
                        </ul>
                        <p>
                          <strong>Sensitive Information.</strong> We do not
                          process sensitive information.
                        </p>
                        <p>
                          <strong>Payment Data.</strong> We may collect data
                          necessary to process your payment if you choose to
                          make purchases, such as your payment instrument
                          number, and the security code associated with your
                          payment instrument. All payment data is handled and
                          stored by Paystack. You may find their privacy notice
                          link(s) here: https://paystack.com/privacy/merchant.
                        </p>
                        <p>
                          <strong>Social Media Login Data.</strong> We may
                          provide you with the option to register with us using
                          your existing social media account details, like your
                          Facebook, X, or other social media account. If you
                          choose to register in this way, we will collect
                          certain profile information about you from the social
                          media provider, as described in the section called
                          'HOW DO WE HANDLE YOUR SOCIAL LOGINS?' below.
                        </p>
                        <p>
                          <strong>Application Data.</strong> If you use our
                          application(s), we also may collect the following
                          information if you choose to provide us with access or
                          permission:
                        </p>
                        <ul>
                          <li>
                            <strong>Mobile Device Access.</strong> We may
                            request access or permission to certain features
                            from your mobile device, including your mobile
                            device's camera, storage, and other features. If you
                            wish to change our access or permissions, you may do
                            so in your device's settings.
                          </li>
                          <li>
                            <strong>Push Notifications.</strong> We may request
                            to send you push notifications regarding your
                            account or certain features of the application(s).
                            If you wish to opt out from receiving these types of
                            communications, you may turn them off in your
                            device's settings.
                          </li>
                        </ul>
                        <p>
                          This information is primarily needed to maintain the
                          security and operation of our application(s), for
                          troubleshooting, and for our internal analytics and
                          reporting purposes.
                        </p>
                        <p>
                          All personal information that you provide to us must
                          be true, complete, and accurate, and you must notify
                          us of any changes to such personal information.
                        </p>

                        <h2>2. HOW DO WE PROCESS YOUR INFORMATION?</h2>
                        <p>
                          <em>In Short:</em> We process your information to
                          provide, improve, and administer our Services,
                          communicate with you, for security and fraud
                          prevention, and to comply with law. We may also
                          process your information for other purposes with your
                          consent.
                        </p>
                        <p>
                          We process your personal information for a variety of
                          reasons, depending on how you interact with our
                          Services, including:
                        </p>
                        <ul>
                          <li>
                            To facilitate account creation and authentication
                            and otherwise manage user accounts. We may process
                            your information so you can create and log in to
                            your account, as well as keep your account in
                            working order.
                          </li>
                          <li>
                            To deliver and facilitate delivery of services to
                            the user. We may process your information to provide
                            you with the requested service.
                          </li>
                          <li>
                            To send administrative information to you. We may
                            process your information to send you details about
                            our products and services, changes to our terms and
                            policies, and other similar information.
                          </li>
                          <li>
                            To enable user-to-user communications. We may
                            process your information if you choose to use any of
                            our offerings that allow for communication with
                            another user.
                          </li>
                          <li>
                            To request feedback. We may process your information
                            when necessary to request feedback and to contact
                            you about your use of our Services.
                          </li>
                          <li>
                            To post testimonials. We post testimonials on our
                            Services that may contain personal information.
                          </li>
                          <li>
                            To match user with right partner.
                          </li>
                        </ul>

                        <h2>
                          3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL
                          INFORMATION?
                        </h2>
                        <p>
                          <em>In Short:</em> We may share information in
                          specific situations described in this section and/or
                          with the following third parties.
                        </p>
                        <p>
                          We may need to share your personal information in the
                          following situations:
                        </p>
                        <ul>
                          <li>
                            <strong>Business Transfers.</strong> We may share or
                            transfer your information in connection with, or
                            during negotiations of, any merger, sale of company
                            assets, financing, or acquisition of all or a
                            portion of our business to another company.
                          </li>
                          <li>
                            <strong>Other Users.</strong> When you share
                            personal information (for example, by posting
                            comments, contributions, or other content to the
                            Services) or otherwise interact with public areas of
                            the Services, such personal information may be
                            viewed by all users and may be publicly made
                            available outside the Services in perpetuity. Your contacts on the social
                            network will see your name, profile photo, and
                            descriptions of your activity. Similarly, other
                            users will be able to view descriptions of your
                            activity, communicate with you within our Services,
                            and view your profile.
                          </li>
                        </ul>

                        <h2>4. HOW DO WE HANDLE YOUR SOCIAL LOGINS?</h2>
                        <p>
                          <em>In Short:</em> If you choose to register or log in
                          to our Services using a social media account, we may
                          have access to certain information about you.
                        </p>
                        <p>
                          Our Services offer you the ability to register and log
                          in using your third-party social media account details
                          (like your Facebook or X logins). Where you choose to
                          do this, we will receive certain profile information
                          about you from your social media provider. The profile
                          information we receive may vary depending on the
                          social media provider concerned, but will often
                          include your name, email address, friends list, and
                          profile picture, as well as other information you
                          choose to make public on such a social media platform.
                        </p>
                        <p>
                          We will use the information we receive only for the
                          purposes that are described in this Privacy Notice or
                          that are otherwise made clear to you on the relevant
                          Services. Please note that we do not control, and are
                          not responsible for, other uses of your personal
                          information by your third-party social media provider.
                          We recommend that you review their privacy notice to
                          understand how they collect, use, and share your
                          personal information, and how you can set your privacy
                          preferences on their sites and apps.
                        </p>

                        <h2>5. HOW LONG DO WE KEEP YOUR INFORMATION?</h2>
                        <p>
                          <em>In Short:</em> We keep your information for as
                          long as necessary to fulfil the purposes outlined in
                          this Privacy Notice unless otherwise required by law.
                        </p>
                        <p>
                          We will only keep your personal information for as
                          long as it is necessary for the purposes set out in
                          this Privacy Notice, unless a longer retention period
                          is required or permitted by law (such as tax,
                          accounting, or other legal requirements). No purpose
                          in this notice will require us keeping your personal
                          information for longer than the period of time in
                          which users have an account with us.
                        </p>
                        <p>
                          When we have no ongoing legitimate business need to
                          process your personal information, we will either
                          delete or anonymise such information, or, if this is
                          not possible (for example, because your personal
                          information has been stored in backup archives), then
                          we will securely store your personal information and
                          isolate it from any further processing until deletion
                          is possible.
                        </p>

                        <h2>6. HOW DO WE KEEP YOUR INFORMATION SAFE?</h2>
                        <p>
                          <em>In Short:</em> We aim to protect your personal
                          information through a system of organisational and
                          technical security measures.
                        </p>
                        <p>
                          We have implemented appropriate and reasonable
                          technical and organisational security measures
                          designed to protect the security of any personal
                          information we process. However, despite our
                          safeguards and efforts to secure your information, no
                          electronic transmission over the Internet or
                          information storage technology can be guaranteed to be
                          100% secure, so we cannot promise or guarantee that
                          hackers, cybercriminals, or other unauthorised third
                          parties will not be able to defeat our security and
                          improperly collect, access, steal, or modify your
                          information. Although we will do our best to protect
                          your personal information, transmission of personal
                          information to and from our Services is at your own
                          risk. You should only access the Services within a
                          secure environment.
                        </p>

                        <h2>7. DO WE COLLECT INFORMATION FROM MINORS?</h2>
                        <p>
                          <em>In Short:</em> We do not knowingly collect data
                          from or market to children under 18 years of age.
                        </p>
                        <p>
                          We do not knowingly collect, solicit data from, or
                          market to children under 18 years of age, nor do we
                          knowingly sell such personal information. By using the
                          Services, you represent that you are at least 18 or
                          that you are the parent or guardian of such a minor
                          and consent to such minor dependent's use of the
                          Services. If we learn that personal information from
                          users less than 18 years of age has been collected, we
                          will deactivate the account and take reasonable
                          measures to promptly delete such data from our
                          records. If you become aware of any data we may have
                          collected from children under age 18, please contact
                          us at hello@tegalapp.com.
                        </p>

                        <h2>8. WHAT ARE YOUR PRIVACY RIGHTS?</h2>
                        <p>
                          <em>In Short:</em> You may review, change, or
                          terminate your account at any time, depending on your
                          country, province, or state of residence.
                        </p>
                        <p>
                          <strong>Withdrawing your consent:</strong> If we are
                          relying on your consent to process your personal
                          information, which may be express and/or implied
                          consent depending on the applicable law, you have the
                          right to withdraw your consent at any time. You can
                          withdraw your consent at any time by contacting us by
                          using the contact details provided in the section 'HOW
                          CAN YOU CONTACT US ABOUT THIS NOTICE?' below.
                        </p>
                        <p>
                          However, please note that this will not affect the
                          lawfulness of the processing before its withdrawal
                          nor, when applicable law allows, will it affect the
                          processing of your personal information conducted in
                          reliance on lawful processing grounds other than
                          consent.
                        </p>
                        <p>
                          <strong>Account Information</strong>
                        </p>
                        <p>
                          If you would at any time like to review or change the
                          information in your account or terminate your account,
                          you can:
                        </p>
                        <ul>
                          <li>
                            Log in to your account settings and update your user
                            account.
                          </li>
                          <li>
                            Contact us using the contact information provided.
                          </li>
                          <li>
                            Submit account deletion request from our website
                          </li>
                          <li>
                            Navigate to Settings of the app and delete your
                            account when needed
                          </li>
                        </ul>
                        <p>
                          Upon your request to terminate your account, we will
                          deactivate or delete your account and information from
                          our active databases. However, we may retain some
                          information in our files to prevent fraud,
                          troubleshoot problems, assist with any investigations,
                          enforce our legal terms and/or comply with applicable
                          legal requirements.
                        </p>
                        <p>
                          If you have questions or comments about your privacy
                          rights, you may email us at hello@tegalapp.com.
                        </p>

                        <h2>9. CONTROLS FOR DO-NOT-TRACK FEATURES</h2>
                        <p>
                          Most web browsers and some mobile operating systems
                          and mobile applications include a Do-Not-Track ('DNT')
                          feature or setting you can activate to signal your
                          privacy preference not to have data about your online
                          browsing activities monitored and collected. At this
                          stage, no uniform technology standard for recognising
                          and implementing DNT signals has been finalised. As
                          such, we do not currently respond to DNT browser
                          signals or any other mechanism that automatically
                          communicates your choice not to be tracked online. If
                          a standard for online tracking is adopted that we must
                          follow in the future, we will inform you about that
                          practice in a revised version of this Privacy Notice.
                        </p>

                        <h2>
                          10. DO OTHER REGIONS HAVE SPECIFIC PRIVACY RIGHTS?
                        </h2>
                        <p>
                          <em>In Short:</em> You may have additional rights
                          based on the country you reside in.
                        </p>
                        <h3>Republic of South Africa</h3>
                        <p>
                          At any time, you have the right to request access to
                          or correction of your personal information. You can
                          make such a request by contacting us by using the
                          contact details provided in the section 'HOW CAN YOU
                          REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
                          YOU?'
                        </p>
                        <p>
                          If you are unsatisfied with the manner in which we
                          address any complaint with regard to our processing of
                          personal information, you can contact the office of
                          the regulator, the details of which are:
                        </p>
                        <p>
                          The Information Regulator (South Africa)
                          <br />
                          General enquiries: enquiries@inforegulator.org.za
                          <br />
                          Complaints (complete POPIA/PAIA form 5):
                          PAIAComplaints@inforegulator.org.za &
                          POPIAComplaints@inforegulator.org.za
                        </p>

                        <h2>11. DO WE MAKE UPDATES TO THIS NOTICE?</h2>
                        <p>
                          <em>In Short:</em> Yes, we will update this notice as
                          necessary to stay compliant with relevant laws.
                        </p>
                        <p>
                          We may update this Privacy Notice from time to time.
                          The updated version will be indicated by an updated
                          'Revised' date at the top of this Privacy Notice. If
                          we make material changes to this Privacy Notice, we
                          may notify you either by prominently posting a notice
                          of such changes or by directly sending you a
                          notification. We encourage you to review this Privacy
                          Notice frequently to be informed of how we are
                          protecting your information.
                        </p>

                        <h2>12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h2>
                        <p>
                          If you have questions or comments about this notice,
                          you may email us at hello@tegalapp.com or contact us
                          by post at:
                        </p>
                        <p>
                          Tegal
                          <br />
                          Ihesiaba Court, Ishaya Shekari Crescent by Federal
                          Staff Housing Estate, Gwarinpa, Abuja, FCT Nigeria
                          <br />
                          West Africa, Abuja Nigeria
                        </p>

                        <h2>
                          13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE
                          COLLECT FROM YOU?
                        </h2>
                        <p>
                          Based on the applicable laws of your country, you may
                          have the right to request access to the personal
                          information we collect from you, details about how we
                          have processed it, correct inaccuracies, or delete
                          your personal information. You may also have the right
                          to withdraw your consent to our processing of your
                          personal information. These rights may be limited in
                          some circumstances by applicable law.
                        </p>
                        <p>
                          To request to review, update, or delete your personal
                          information, please fill out and submit a data subject
                          access request.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
}

export default PrivacyPolicy;
